// src/data/consultationHistoryMockData.js

export const consultationHistoryData = [
  {
    consultationId: 1,
    patientId: 1,
    patientName: 'Rahul Das',
    doctor: 'Dr. Sushmita Sharma',
    consultationDate: '2024-08-14T10:00:00',
    diagnosis: 'Generalized Anxiety Disorder',
    prescription: [
      {
        medication: 'Prozac 20mg',
        dosage: '1 tablet daily',
        duration: '30 days',
        instructions: 'Take with food',
      },
      {
        medication: 'Xanax 0.5mg',
        dosage: 'As needed',
        duration: '15 days',
        instructions: 'Take only when needed for anxiety',
      },
    ],
    notes:
      'Patient responded well to treatment. Suggested follow-up in 2 weeks.',
    consultationType: 'Follow-Up',
    duration: '30 mins',
    testsOrdered: [
      {
        testName: 'Blood Test',
        instructions: 'Fast for 12 hours before the test',
      },
    ],
    referrals: [
      {
        specialist: 'Cardiologist',
        reason: 'Check for underlying heart issues',
      },
    ],
  },

  {
    consultationId: 1,
    patientId: 1,
    patientName: 'Rahul Das',
    doctor: 'Dr. Sushmita Sharma',
    consultationDate: '2024-08-14T10:00:00',
    diagnosis: 'Generalized Anxiety Disorder',
    prescription: [
      {
        medication: 'Prozac 20mg',
        dosage: '1 tablet daily',
        duration: '30 days',
      },
      { medication: 'Xanax 0.5mg', dosage: 'As needed', duration: '15 days' },
    ],
    notes:
      'Patient responded well to treatment. Suggested follow-up in 2 weeks.',
    consultationType: 'Follow-Up',
    duration: '30 mins',
  },
  {
    consultationId: 2,
    patientId: 2,
    patientName: 'Priya Sen',
    doctor: 'Dr. Rakesh Gupta',
    consultationDate: '2024-08-15T14:00:00',
    diagnosis: 'Mild to Moderate Depression',
    prescription: [
      {
        medication: 'Sertraline 50mg',
        dosage: '1 tablet daily',
        duration: '30 days',
      },
    ],
    notes: 'Patient is stable. Therapy recommended.',
    consultationType: 'Initial Consultation',
    duration: '60 mins',
  },
];
